/**
 * @Author: hangbale
 * @Date:   2017-08-03
 * @Email:  571312070@qq.com
 * @Last modified by:   hangbale
 * @Last modified time: 2017-08-15
 */

// listen函数用来监听事件，并传入回调函数
// 不需要监听时,使用removeListener清楚事件
// 后端传回的token保存在user.token中
// 其他个人信息放在user.info中
// 这是一个全局插件
// 使用之前 在main.js中配置
// 然后在各个组件中引入vue即可使用
// 使用方法
// Vue.auth.listen('login', function () {
//     console.log('login');
// })
// Vue.dispatch('login');

const setCookie = function (name, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = name + "=" + escape(value) +
        ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

const getCookie = function(name) {
    let start, end;
    if (document.cookie.length > 0) {
        let start = document.cookie.indexOf(name + "=");
        if (start != -1) {
            start = start + name.length + 1;
            end = document.cookie.indexOf(";", start);
            if (end == -1) {
                end = document.cookie.length;
            }
            return unescape(document.cookie.substring(start, end));
        }
    }
    return null;
}
function deleteCookie( name, path, domain ) {
  if( get_cookie( name ) ) {
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}


export default function (Vue) {
    Vue.auth = {
        user: {
            token: null,
            info: null
        },
        events: {},
        listen: function (eventname, callback) {
            if (!this.events[eventname]) {
                this.events[eventname] = {};
                this.events[eventname].type = eventname;
                this.events[eventname].callback = callback;
            }
        },
        dispatch: function (eventname) {
            this.events[eventname].callback();
        },
        setToken: function (token) {
            this.user.token = token;
            setCookie('token', token, 7);
        },
        setUserInfo: function (info) {
            this.user.info = info;
            setCookie('info', info, 7);
        },
        getUserInfo : function () {
            if (this.user.info) {
                return this.user.info;
            } else if (getCookie('info')) {
                return getCookie('info');
            } else {
                return null;
            }
        },
        getToken: function () {
            if (this.user.token) {
                return this.user.token;
            } else if (getCookie('token')) {
                return getCookie('token');
            } else {
                return '';
            }
        },
        removeListener: function (eventname) {
            if (!this.events[eventname]) {
                return;
            } else {
                this.events[eventname] = null;
            }
        },
        logOut: function () {
            this.user.token = null;
            this.user.info = null;
            deleteCookie('token');
            deleteCookie('info');
        }
    }
}



// WEBPACK FOOTER //
// ./src/service/auth.js